import React from "react";

const FormError = ({ children }) => {
  return <p className="text-sm text-red-500">{children}</p>;
};

export default FormError;
